import React, { useState, useEffect, useRef } from "react";
import _, { set } from "lodash";
import { Segment, Dropdown } from "semantic-ui-react";
import ReactTable from "react-table-v6";
import { Header, Loader, Grid,Icon } from "semantic-ui-react";
import { useGetDeckPathQuery, useGetSurveyQuestionsPathQuery } from "@api/apiV6";
import { Div, Button } from "@components/Generics.react";
export default function AssessmentLearnersSubPanel(props) {
  const isPortrait = window.innerHeight > window.innerWidth;
  const reactTableRef = useRef(null);
  const [questionResponse, setQuestionResponse] = useState(null);
  const [questionData, setQuestionData] = useState(null)
  const [learnerData, setLearnerData] = useState(null);

  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const { activeTopic, results } = props;

  const deckId = activeTopic;

  const { data: assessmentData } = useGetDeckPathQuery({ deckId: deckId });
  const { data: surveyData } = useGetSurveyQuestionsPathQuery({ deckId: deckId });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const questionData = assessmentData.content.map((slide, index) => ({
          key: deckId + "#" + slide.slideSeq,
          value: deckId + "#" + slide.slideSeq,
          text: slide.data.question,
          template: slide.template,
          data: slide.data,
          sequence: index,
        }));

        const learnerData = _.map(
          surveyData.questions,
          (question) => {
            let targetQuestion = _.find(
              questionData,
              {
                key: question._id,
              }
            );
            return {
              id: targetQuestion.key,
              question: targetQuestion.text,
              template: targetQuestion.template,
              data: targetQuestion?.data,
              learners: question?.learners,
            };
          }
        )

        if (learnerData) {
          setQuestionData(questionData);
          setLearnerData(learnerData);

        }
      } catch (e) {
        console.log(e)
      }
    };
    fetchData();
  }, [results])



  useEffect(
    () => {
      const selectedResponse = _.find(learnerData, {
        id: selectedQuestion,
      });

      if (selectedResponse !== undefined) {
        const questionResponse = _.map(selectedResponse?.learners, (learner) => {
          const user = _.find(results, {
            user_id: learner._id,
          });

          return {
            username: user?.username,
            response: handleResponse(
              selectedQuestion?.template,
              selectedQuestion?.data,
              learner?.response
            ),
          };
        });

        if (questionResponse) {
          setQuestionResponse(questionResponse);
        }
      }
    },
    [

      learnerData,
      selectedQuestion,

      results,

    ]
  );

  const handleResponse = (template, data, response) => {
    try {
      switch (template) {
        case "true_false":
          return data.choice[response].text;
        case "single_select":
          return data.options[response].text;
        case "multiple_select":
          return _.map(response, (selection) => {
            return data.multiselect[selection].text;
          }).join("; ");
        case "fill_in_the_blanks":
        default:
          return response;
      }
    } catch (e) {
      this.setState({
        fetchCompleted: true,
        unavailable: true,
      });
    }
  };

  const fullColumns = [
    {
      Header: "Learner",
      accessor: "username",
      minWidth: 128,
      style: { textAlign: "center", whiteSpace: "unset" },
    },
    {
      Header: "Response",
      id: "response",
      accessor: (d) => d.response,
      style: { textAlign: "center", whiteSpace: "unset" },
    },
  ];

  return (
    <Div vapor rounded relaxed={!isPortrait} small>
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column teal>
            <Div spaced charcol bold nopad left-align large uppercase>
              Select a Question
            </Div>
          </Grid.Column>
          <Grid.Column floated='left'>
            <Div spaced
              vapor
              right-align
            >
              <Button charcol>
                <Icon name='download' />
                Download CSV
              </Button>
            </Div>

          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid.Row>
        <Dropdown
          placeholder="Select Learners"
          search
          fluid
          selection
          options={questionData}
          onChange={(e, { value }) => setSelectedQuestion(value)}
        />
        <br />
        <ReactTable
          ref={reactTableRef}
          data={questionResponse || []}
          filterable
          defaultFilterMethod={(filter, row, column) => {
            const id = filter.pivotId || filter.id;
            return row[id] !== undefined
              ? String(row[id]).includes(filter.value)
              : true;
          }}
          pageSizeOptions={[5, 10]}
          columns={fullColumns}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </Grid.Row>
    </Div>
  );
}
